<ng-container *ngIf="element">
  <app-element-single-line
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.SingleLineText"
  />

  <app-element-multi-line
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.MultiLineText"
  />

  <app-element-radio
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    [showCompletionWarning]="showCompletionWarning"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.Radio"
  />

  <app-element-checkbox
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.Checkbox"
  />

  <app-element-dropdown
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    [showCompletionWarning]="showCompletionWarning"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.Dropdown"
  />

  <app-element-date
    [element]="element"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    [index]="index" *ngIf="element.elementType === DiaryFormElementType.Date"
  />

  <app-element-time
    [element]="element"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    [index]="index" *ngIf="element.elementType === DiaryFormElementType.Time"
  />

  <app-element-numeric
    [element]="element"
    [index]="index"
    [hasEntries]="hasEntries"
    [allElements]="allElements"
    [showCompletionWarning]="showCompletionWarning"
    (elementMoveUp)="elementMoveUp.emit(element)"
    (elementMoveDown)="elementMoveDown.emit(element)"
    (elementRemove)="elementRemove.emit(element)"
    (elementManage)="elementManage.emit(element)"
    (messageRemove)="messageRemove.emit($event)"
    (messageEdit)="messageEdit.emit($event)"
    (messageAdd)="messageAdd.emit(element)"
    (visibilityEdit)="visibilityEdit.emit(element)"
    *ngIf="element.elementType === DiaryFormElementType.Numeric"
  />
</ng-container>
